var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "preview",
      class: {
        desktop: _vm.device === 1,
        tablet: _vm.device === 2,
        ios: _vm.device === 3,
        android: _vm.device === 4,
      },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex flex-column justify-content-center align-items-center",
        },
        [
          _c(
            "a-button-group",
            { staticClass: "mb-1" },
            [
              _c(
                "a-button",
                {
                  attrs: { type: _vm.device === 1 ? "primary" : "" },
                  on: {
                    click: function ($event) {
                      _vm.device = 1
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("fastWizard.previewDesktop")) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  attrs: { type: _vm.device === 2 ? "primary" : "" },
                  on: {
                    click: function ($event) {
                      _vm.device = 2
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("fastWizard.previewIpad")) + "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  attrs: { type: _vm.device === 3 ? "primary" : "" },
                  on: {
                    click: function ($event) {
                      _vm.device = 3
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("fastWizard.previewIOS")))]
              ),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  attrs: { type: _vm.device === 4 ? "primary" : "" },
                  on: {
                    click: function ($event) {
                      _vm.device = 4
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("fastWizard.previewAndroid")))]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "position-relative" }, [
            _vm.device === 1
              ? _c(
                  "div",
                  { staticClass: "marvel-device macbook position-relative" },
                  [
                    _c("div", { staticClass: "top-bar" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "camera" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "screen" }, [
                      !!_vm.settings.website &&
                      _vm.uploaded.includes(_vm.settings.website)
                        ? _c("img", {
                            key: "desktop" + _vm.renderCount,
                            staticStyle: { width: "100%", height: "100%" },
                            attrs: { src: _vm.screenshots().desktop },
                          })
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "bottom-bar" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "livePreviewAbsolute" },
                      [_c("LivePreview")],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.device === 2
              ? _c("div", { staticClass: "marvel-device ipad silver" }, [
                  _c("div", { staticClass: "camera" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "screen" }, [
                    !!_vm.settings.website &&
                    _vm.uploaded.includes(_vm.settings.website)
                      ? _c("img", {
                          key: "tablet" + _vm.renderCount,
                          staticStyle: { width: "100%", height: "100%" },
                          attrs: { src: _vm.screenshots().tablet },
                        })
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "home" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "livePreviewAbsolute" },
                    [_c("LivePreview")],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.device === 3
              ? _c(
                  "div",
                  { staticClass: "marvel-device iphone-x position-relative" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "top-bar" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "sleep" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "bottom-bar" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "volume" }),
                    _vm._v(" "),
                    _vm._m(1),
                    _vm._v(" "),
                    _c("div", { staticClass: "inner-shadow" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "screen" }, [
                      !!_vm.settings.website &&
                      _vm.uploaded.includes(_vm.settings.website)
                        ? _c("img", {
                            key: "ios" + "" + _vm.renderCount,
                            staticStyle: { width: "100%", height: "100%" },
                            attrs: { src: _vm.screenshots().mobile },
                          })
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "livePreviewAbsolute" },
                      [_c("LivePreview")],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.device === 4
              ? _c(
                  "div",
                  { staticClass: "marvel-device note8 position-relative" },
                  [
                    _c("div", { staticClass: "inner" }),
                    _vm._v(" "),
                    _vm._m(2),
                    _vm._v(" "),
                    _c("div", { staticClass: "speaker" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "sensors" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "more-sensors" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "sleep" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "volume" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "camera" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "screen" }, [
                      !!_vm.settings.website &&
                      _vm.uploaded.includes(_vm.settings.website)
                        ? _c("img", {
                            key: "android" + _vm.renderCount,
                            staticStyle: { width: "100%", height: "100%" },
                            attrs: { src: _vm.screenshots().mobile },
                          })
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "livePreviewAbsolute" },
                      [_c("LivePreview")],
                      1
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "notch" }, [
      _c("div", { staticClass: "camera" }),
      _vm._v(" "),
      _c("div", { staticClass: "speaker" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "overflow" }, [
      _c("div", { staticClass: "shadow shadow--tr" }),
      _vm._v(" "),
      _c("div", { staticClass: "shadow shadow--tl" }),
      _vm._v(" "),
      _c("div", { staticClass: "shadow shadow--br" }),
      _vm._v(" "),
      _c("div", { staticClass: "shadow shadow--bl" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "overflow" }, [
      _c("div", { staticClass: "shadow" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }